import { Box, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPaymentRequestsState, getCancelTransaction, setCancelTransactionErrorClear } from '../../pmui/paymentrequests/sagas/paymentrequestslice';
import WhiteInosio from '../../icons/whiteinosio.svg';
import QuickPayMethodsDialog from './components/QuickPayMethodsDialog';
import { CreateOneTimePaymentDto, PaymentTypeEnum, QuickPayTypeDto } from '@inosio/payments-sdk';
import AddCardModal from '../../shared/MakePayment/Components/AddCardModal';
import AddBankAccountModal from '../../shared/MakePayment/Components/AddBankAccountModal';
import { makeStyles } from '@mui/styles';
import SpinnerModal from '../../shared/Modal/SpinnerModal';
import { useParams } from 'react-router-dom';
import QuickPayItemDialog from './components/QuickPayItemDialog';
import AddGenericPayerModal from './components/AddGenericPayerDialog';
import { getBuildQuickPayOTPDto, getMakeQuickPayOtp, selectQuickPaymentsState, setMakeQuickPayOtpErrorClear } from './sagas/quickpaymentsSlice';
import QuickPayReviewDialog from './components/QuickPayReviewDialog';
import QuickPayThankYouPaymentDialog from './components/QuickPayThankYouPaymentDialog';
import ConfirmCancelModal from '../../shared/MakePayment/Components/ConfirmCancelModal';
import { getCompany, getPropertyGroupDetails, selectPropertyGroupDetailsState } from '../../shared/sagas/propertyGroups/propertyGroupsSlice';

const useStyles = makeStyles((theme) => ({
  forgetText: {
    font: '14px Work Sans',
    lineHeight: '30px',
    color: '#39A2DB',
    textDecoration: 'none !important',
    maxHeight: '30px !important',
    margin: '10px !important',
    marginTop: '8px !important',
    marginBottom: '27px !important',
    paddingLeft: '5px !important',
    cursor: 'pointer',
  },
}));

export default function QuickPayment() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isOnMobileHeight = useMediaQuery('(max-height:900px)');
  const isOnMobileScreen = useMediaQuery('(max-width:600px)');
  const { organization_uuid } = useParams<{ organization_uuid: string }>(); //must keept this for backwards compatibility since we moved to property groups

  const [fetchPropertyGroupCount, setFetchPropertyGroupCount] = React.useState(0);
  const [fetchCompanyInfoCount, setFetchCompanyInfoCount] = React.useState(0);
  const { propertyGroupDetails: PropertyGroupDetails, isFetchingPropertyGroupDetailsFailed, companyInfo } = useSelector(selectPropertyGroupDetailsState);

  React.useEffect(() => {
    if (!organization_uuid) return;
    //try /assume organization_uuid is a property group first.
    if (fetchPropertyGroupCount === 0) {
      dispatch({ type: getPropertyGroupDetails.type, payload: { propertyGroupUuid: organization_uuid, productTypeId: [1] } });//fetch prop group details
      setFetchPropertyGroupCount(fetchPropertyGroupCount + 1);
      return;
    } else if (isFetchingPropertyGroupDetailsFailed && fetchCompanyInfoCount === 0) {
      //if that fails, then see if it's a company guid
      dispatch({ type: getCompany.type, payload: { companyUuid: organization_uuid } });
      setFetchCompanyInfoCount(fetchCompanyInfoCount + 1);
      return;
    }
    //if that succeeds, then try to fetch the property group again.
    if (companyInfo?.DefaultPropertyGroupUuid && fetchPropertyGroupCount === 1) {
      //we only want to try this one more time.
      dispatch({ type: getPropertyGroupDetails.type, payload: { propertyGroupUuid: companyInfo?.DefaultPropertyGroupUuid, productTypeId: [1] } });//fetch prop group details
      setFetchPropertyGroupCount(fetchPropertyGroupCount + 1);
      return;
    }
  }, [organization_uuid, isFetchingPropertyGroupDetailsFailed, companyInfo, dispatch]);

  const { isCreatingOtp, isSuccessOtp, quickPaymentFees, quickPayOtpDto, selectedPaymentOption, QPTransactionDto, genericPayerResponse } = useSelector(selectQuickPaymentsState);
  const { BankAccount, BankCard, errorCancelTransaction, isFetchingCancelTransaction, isSuccessCancelTransaction } = useSelector(selectPaymentRequestsState);

  const [openQuickPayItemDialog, setOpenQuickPayItemDialog] = useState(true);
  const [quickPayItem, setQuickPayItem] = useState<QuickPayTypeDto>();
  const [openAddGenericPayerDialog, setOpenAddGenericPayerDialog] = useState(false);
  const [openQuickPayMethodsDialog, setOpenQuickPayMethodsDialog] = useState(false);
  const [openAddCardDialog, setOpenAddCardDialog] = useState(false);
  const [openAddBankAccountDialog, setOpenAddBankAccountDialog] = useState(false);
  const [openReviewAndSubmitDialog, setOpenReviewAndSumitDialog] = useState(false);
  const [openThankYouForYourPaymentDialog, setThankYouForYourPaymentDialog] = useState(false);
  const [openConfirmCancelDialog, setConfirmCancelDialog] = useState(false);
  const [isSpinnerModalOpen, setIsSpinnerModalOpen] = React.useState(false);
  const [spinnerStatus, setSpinnerStatus] = React.useState<string | null>(null);

  //spinner modal states
  useEffect(() => {
    if (isCreatingOtp && !isSuccessOtp) {
      setIsSpinnerModalOpen(true);
    }
    if (isSuccessOtp && !isCreatingOtp) {
      setSpinnerStatus('start');
    } else if (!isCreatingOtp && !isSuccessOtp) {
      setIsSpinnerModalOpen(false);
    }
  }, [isCreatingOtp, isSuccessOtp]);

  useEffect(() => {
    if (isFetchingCancelTransaction && !isSuccessCancelTransaction) {
      setIsSpinnerModalOpen(true);
    }
    if (isSuccessCancelTransaction && !isFetchingCancelTransaction) {
      setSpinnerStatus('start');
    } else if (!isFetchingCancelTransaction && !isSuccessCancelTransaction) {
      setIsSpinnerModalOpen(false);
    }
  }, [isFetchingCancelTransaction, isSuccessCancelTransaction, errorCancelTransaction]);

  useEffect(() => {
    if (isSuccessCancelTransaction) {
      // setOpenPRCancelledModalDialog(true);
    }
  }, [isSuccessCancelTransaction]);

  //resetting global error states
  const resetOtpError = () => {
    dispatch({
      type: setMakeQuickPayOtpErrorClear.type,
    });
  };

  return (
    <Box sx={{ backgroundColor: '#F1F0F5', height: '100vh', display: 'flex', justifyContent: 'center', width: '100vw' }}>
      {isOnMobileHeight ? (
        <></>
      ) : (
        <Grid item display="flex" justifyContent="center" ml={6} sx={{ width: '300px', position: 'relative', top: '10%' }}>
          <img src={WhiteInosio} style={{ width: '75px', height: '75px' }} alt="logo" />
          <Typography
            sx={{
              fontFamily: 'Work Sans',
              fontStyle: 'normal',
              fontWeight: 700,
              fontSize: '18px',
              lineHeight: '23px',
              color: '#14142B',
              textAlign: 'left',
              padding: '15px',
            }}
          >
            {PropertyGroupDetails?.CompanyName}
          </Typography>
        </Grid>
      )}

      {/* Summary of Payment Request */}
      <QuickPayItemDialog
        open={openQuickPayItemDialog}
        onContinue={(item: QuickPayTypeDto) => {
          setOpenQuickPayItemDialog(false);
          setQuickPayItem(item);
          setOpenAddGenericPayerDialog(true);
        }}
      />

      {/* Add Generic Payer Detail */}
      <AddGenericPayerModal
        open={openAddGenericPayerDialog}
        onContinue={() => {
          setOpenAddGenericPayerDialog(false);
          setOpenQuickPayMethodsDialog(true);
        }}
        onBackClick={() => {
          setOpenQuickPayItemDialog(true);
          setOpenAddGenericPayerDialog(false);
        }}
      />

      {/* Choose Payment Method Type */}
      <QuickPayMethodsDialog
        open={openQuickPayMethodsDialog}
        onClickCardIcon={() => {
          setOpenQuickPayMethodsDialog(false);
          setOpenAddCardDialog(true);
        }}
        onClickBankIcon={() => {
          setOpenAddBankAccountDialog(true);
        }}
        onBackClick={() => {
          setOpenQuickPayMethodsDialog(false);
          setOpenAddGenericPayerDialog(true);
        }}
        quickPayItem={quickPayItem}
      />

      {/* Enter Card Details */}
      <AddCardModal
        open={openAddCardDialog}
        onBackClick={() => {
          setOpenAddCardDialog(false);
          setOpenQuickPayMethodsDialog(true);
        }}
        onContinue={(agreedUponFeeAmt: number) => {
          setOpenReviewAndSumitDialog(true);
          const currentTotal = quickPayOtpDto.TotalAmount;
          const currentFee = quickPayOtpDto.FeeAmount || 0;
          const currentPaymentAmt = currentTotal - currentFee;
          const newTotal = currentPaymentAmt + agreedUponFeeAmt;
          dispatch({
            type: getBuildQuickPayOTPDto.type,
            payload: { BankCard, TotalAmount: newTotal, FeeAmount: agreedUponFeeAmt } as Partial<CreateOneTimePaymentDto>,
          });
        }}
        CardType={selectedPaymentOption}
        Fees={{ CC: quickPaymentFees.find((f) => f.PaymentType === PaymentTypeEnum.Cc)?.FeeAmount || 0, DB: quickPaymentFees.find((f) => f.PaymentType === PaymentTypeEnum.Db)?.FeeAmount || 0 }}
        CompanyName={PropertyGroupDetails?.CompanyName ?? ''}
      />

      {/* Enter Bank Account Details */}
      <AddBankAccountModal
        open={openAddBankAccountDialog}
        onContinue={() => {
          setOpenReviewAndSumitDialog(true);
          dispatch({
            type: getBuildQuickPayOTPDto.type,
            payload: { BankAccount } as Partial<CreateOneTimePaymentDto>,
          });
        }}
        onBackClick={() => {
          setOpenAddBankAccountDialog(false);
          setOpenQuickPayMethodsDialog(true);
        }}
        Fees={quickPayOtpDto.FeeAmount ?? 0}
        CompanyName={PropertyGroupDetails?.CompanyName ?? ''}
      />

      {/* Review And Submit */}
      <QuickPayReviewDialog
        open={openReviewAndSubmitDialog}
        onCloseIcon={() => {
          window.location.reload();
        }}
        onBackClick={() => {
          setOpenReviewAndSumitDialog(false);
          selectedPaymentOption === PaymentTypeEnum.Cc ? setOpenAddCardDialog(true) : selectedPaymentOption === PaymentTypeEnum.Db ? setOpenAddCardDialog(true) : setOpenAddBankAccountDialog(true);
          resetOtpError();
        }}
        onConfirm={() => {
          dispatch({
            type: getBuildQuickPayOTPDto.type,
            payload: {
              BankCard,
              BankAccount,
            } as Partial<CreateOneTimePaymentDto>,
          });
          dispatch({
            type: getMakeQuickPayOtp.type,
            payload: { ...quickPayOtpDto, BankCard, BankAccount },
          });
        }}
        quickPayItem={quickPayItem}
      />

      {/* Thank you for you payment */}
      <QuickPayThankYouPaymentDialog
        open={openThankYouForYourPaymentDialog}
        onCancel={() => {
          setConfirmCancelDialog(true);
          dispatch({
            type: setCancelTransactionErrorClear.type,
          });
        }}
      />

      {/* Confirm Cancel */}
      <ConfirmCancelModal
        open={openConfirmCancelDialog}
        onYes={() => {
          dispatch({
            type: getCancelTransaction.type,
            payload: {
              payerUuid: genericPayerResponse?.Uuid,
              transactionUuid: QPTransactionDto?.TransactionUuid,
            },
          });
          setConfirmCancelDialog(false);
        }}
        onNo={() => {
          setConfirmCancelDialog(false);
          setThankYouForYourPaymentDialog(true);
        }}
        onCloseIcon={() => {
          setConfirmCancelDialog(false);
          setThankYouForYourPaymentDialog(true);
        }}
        CompanyName={PropertyGroupDetails?.CompanyName ?? ''}
      />

      {isSpinnerModalOpen && (
        <SpinnerModal
          isInvisible={true}
          openSpinnerModal={isSpinnerModalOpen}
          spinnerStatus={spinnerStatus}
          handleCloseSpinnerModal={() => {
            if (isSuccessOtp) {
              setThankYouForYourPaymentDialog(true);
            } else {
              setIsSpinnerModalOpen(false);
            }
          }}
          closeCancel={resetOtpError}
          height={isOnMobileScreen ? '100%' : '523px'}
          width={isOnMobileScreen ? '100%' : '472px'}
        />
      )}

      {isOnMobileHeight ? (
        <></>
      ) : (
        <Grid item sx={{ position: 'absolute', bottom: 50, width: '28%', zIndex: 2000 }}>
          <Divider />
          <Grid item display="flex" justifyContent="center">
            <span
              className={classes.forgetText}
              onClick={() => {
                window.open('http://support.inosio.com/');
              }}
            >
              {'Need help?'}
            </span>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}
